<template>
  <b-container>
<h1>Cancel</h1>
  </b-container>
</template>
<script>
import { mixins } from "../mixins";


export default {
  name: "cancel",
  mixins: [mixins],
  data() {
    return {
    };
  },
  created() {
    
  },
  methods: {
    
  }
};
</script>
